import { render, staticRenderFns } from "./TaskCell.vue?vue&type=template&id=42ec21f2&scoped=true"
import script from "./TaskCell.vue?vue&type=script&lang=js"
export * from "./TaskCell.vue?vue&type=script&lang=js"
import style0 from "./TaskCell.vue?vue&type=style&index=0&id=42ec21f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec21f2",
  null
  
)

export default component.exports